import {
  Subscription,
  PCSubscription,
  PCPaymentDetails,
  PaymentDetails,
} from "../../contracts/nexar-api/types";

function hasDate(date: string | null): date is string {
  return !!date && date !== "0001-01-01T00:00:00Z";
}

export const convertSubscription = (
  subscription: PCSubscription
): Subscription => {
  return {
    createdAt: hasDate(subscription.created_at)
      ? new Date(subscription.created_at)
      : null,
    subscriptionId: subscription.id.id,
    userId: subscription.user_id?.id || null,
    serialNumbers: subscription.device_sns,
    status: subscription.status,
    nextBillingDate: hasDate(subscription.next_billing_date)
      ? new Date(subscription.next_billing_date)
      : null,
    lastBillingDate: hasDate(subscription.last_billing_date)
      ? new Date(subscription.last_billing_date)
      : null,
    cancellationCause: subscription.cancellation_cause,
    recurlySubscriptionId: subscription.recurly_subscription_id,
    stripeSubscriptionId: subscription.stripe_subscription_id,
    subscriptionQuantity: subscription.device_sns?.length || null,
    startDate: hasDate(subscription.start_date)
      ? new Date(subscription.start_date)
      : null,
    isPrepaid: subscription.subscription_type === "PREPAID_SUBSCRIPTION",
    campaign: subscription?.campaign || null,
    expirationDate: hasDate(subscription.expiration_date)
      ? new Date(subscription.expiration_date)
      : null,
  };
};

export const convertPaymentDetails = (
  paymentDetails: PaymentDetails
): PCPaymentDetails => {
  const { firstName, lastName, recurlyToken, email } = paymentDetails;
  return {
    first_name: firstName,
    last_name: lastName,
    payment_token: recurlyToken,
    email: email,
  };
};
